import { Grid } from '@mui/material';
import { memo } from 'react';
import Section from 'components/common/Section/Section';
import ProductInfoItem from '../ProductInfoItem/ProductInfoItem';
import { useProductContext } from 'context/ProductContext';
import { colors } from 'styles/colors';


function ProductPublishDetails() {
  const { product } = useProductContext();
  const isPublished = !!product.publishedAt;

  // Outdated is settled on the server: what the last sync sent, compared against
  // what a sync would send now. An edit to something the graph does not hold - a
  // sentence, a photo, a price - leaves this reading Synced.
  const syncedAt = product.graphSyncedAt ? new Date(product.graphSyncedAt) : null;
  const isSynced = !!syncedAt;
  const isOutdated = isSynced && Boolean(product.graphOutdated);

  const syncLabel = !isSynced ? 'Not synced' : isOutdated ? 'Outdated' : 'Synced';
  const syncColor = !isSynced
    ? colors.error
    : isOutdated
      ? colors.warning
      : colors.success;

  return (
    <Section
      title={'Publishing'}
      content={
        <>
          <Grid size={{ xs: 12, md: 6 }}>
            <ProductInfoItem
              label={'Status'}
              value={isPublished ? 'Published' : 'Unpublished'}
              valueColor={isPublished ? colors.success : colors.pending}
            />
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <ProductInfoItem
              label={'Published At'}
              value={product.publishedAt ? new Date(product.publishedAt).toLocaleString() : null}
            />
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <ProductInfoItem
              label={'Graph'}
              value={syncLabel}
              valueColor={syncColor}
            />
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <ProductInfoItem
              label={'Synced At'}
              value={syncedAt ? syncedAt.toLocaleString() : null}
            />
          </Grid>
        </>
      }
    />
  )
}

export default memo(ProductPublishDetails);
